import type { PickFilterDef, PickFilterValues } from '../types';

export function defaultPickFilterValues(
  filters: readonly PickFilterDef[] | undefined
): PickFilterValues {
  const result: PickFilterValues = {};
  for (const filter of filters ?? []) {
    result[filter.id] = filter.defaultValue ?? null;
  }
  return result;
}

export function mergeInitialPickFilterValues(
  filters: readonly PickFilterDef[] | undefined,
  initialValues?: Partial<PickFilterValues>
): PickFilterValues {
  const result = { ...defaultPickFilterValues(filters) };
  if (!initialValues) return result;
  for (const [key, value] of Object.entries(initialValues)) {
    if (value !== undefined) {
      result[key] = value;
    }
  }
  return result;
}
